/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T17:27:30.236
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentPurchaseOrder,
	listRentPurchaseOrderInit,
	listRentPurchaseOrderByAuthorizations,
	deleteRentPurchaseOrder
	
} from '@api/rentmanage/RentPurchaseOrder';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentPurchaseOrder({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPurchaseOrder(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPurchaseOrderByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPurchaseOrderByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPurchaseOrderInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPurchaseOrderInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPurchaseOrder({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPurchaseOrder({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
